import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Container,
  Grid,
  TextField,
  MenuItem,
  Select,
  IconButton,
} from "@material-ui/core";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import ScheduleNext from "../ScheduleNext";
import SchedulePrev from "../SchedulePrev";

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
  },
  textSize: {
    fontSize: 40,
    fontWeight: 900,
    // lineHeight: 32,
    fontFamily: "'Noto Sans KR'",
    textAlign: "center",
  },
}));

interface ScheduleInputProps {
  setMonth: any;
  month: any;
}

function ScheduleInput({ setMonth, month }: ScheduleInputProps) {
  const classes = useStyles();
  // const [prev, setPrev] = useState<any>(null);
  // const [next, setNext] = useState<any>(null);

  // useEffect(() => {
  //   let originMonth = new Date(month);
  //   let originYear = originMonth.getFullYear();
  //   let originMon = originMonth.getMonth();
  //   let nextDate = new Date(originYear, originMon + 1);
  //   let nextYear = nextDate.getFullYear();
  //   let nextMonth = nextDate.getMonth();

  //   setNext(`${nextYear}-${nextMonth + 1}`);

  //   return () => {};
  // }, [month]);

  // useEffect(() => {
  //   let originMonth = new Date(month);
  //   let originYear = originMonth.getFullYear();
  //   let originMon = originMonth.getMonth();
  //   let prevDate = new Date(originYear, originMon );
  //   let prevYear = prevDate.getFullYear();
  //   let prevMonth = prevDate.getMonth();

  //   setPrev(`${prevYear}-${prevMonth }`);

  //   return () => {};
  // }, [month]);

  const monthChange = (event: any) => {
    // setMonth(event.target.value);
  };

  console.log(month);
  return (
    <Grid style={{ paddingTop: 8, paddingBottom: 8 }}>
      {/* <TextField
        // defaultValue="2020-11"
        // type="month"
        size={"medium"}
        onChange={monthChange}
        className={classes.textField}
        InputProps={{
          classes: {
            input: classes.textSize,
          },
        }}
      /> */}
      <Grid
        xs={12}
        container
        item
        // style={{
        //   textAlign: "right",
        //   borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
        //   paddingBottom: 8,
        //   paddingTop: 16,
        // }}
        style={{
          borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
        }}
        className={classes.textSize}
      >
        <Grid item style={{ width: "15%" }}>
          {/* <IconButton
            component={Link}
            to={`/schedule/${prev}`}
            style={
              {
                // position: "absolute",
                // right: "10rem",
                // top: "4rem",
                // paddingBottom: 16,
              }
            }
          >
            <NavigateBeforeIcon style={{ fontSize: 56 }} />
          </IconButton> */}
          <SchedulePrev month={month} />
        </Grid>
        <Grid item style={{ lineHeight: 1.9, width: "70%" }}>
          <Moment locale="ko" format="YYYY년 MMM">
            {month}
          </Moment>
        </Grid>
        <Grid item style={{ width: "15%" }}>
          <ScheduleNext month={month} />
          {/* <IconButton
            component={Link}
            to={`/schedule/${next}`}
            style={
              {
                // paddingBottom: 16,
                // left: "10rem",
                // top: "4rem",
                // position: "absolute",
                // right: "100%",
              }
            }
          >
            <NavigateNextIcon style={{ fontSize: 56 }} />
          </IconButton> */}
        </Grid>
      </Grid>
      {/* <input type="month" id="bdaymonth" name="bdaymonth" /> */}
    </Grid>
  );
}

export default ScheduleInput;
